import { Config, ErrorHandling, HtmlContentEditor, TranslationConfig, getjQuery, notifyInfo } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import { getLanguageList } from "./Helpers/LanguageList";
import { HubConnectionBuilder } from "@microsoft/signalr";

Config.rootNamespaces.push('VishwNetMediaManager');
TranslationConfig.getLanguageList = getLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";
gridDefaults.useCssVars = false;

let $ = getjQuery();
if ($?.fn?.colorbox) {
    $.fn.colorbox.settings.maxWidth = "95%";
    $.fn.colorbox.settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);

//add signalR BEGIN

// The HubConnectionBuilder class creates a new builder for 
// configuring the server connection. 
// The withUrl function configures the hub URL.
// Hub URL was defined in Startup.cs 
const connection = new HubConnectionBuilder()
    .withUrl("/RCSMessagesHub")
    .withAutomaticReconnect()
    .build();

// Listening to a message with the name 'notifyMessage'
// and display the message using Q.notifyInfo
connection.on("notifyMessage", (message) => {
    notifyInfo(message);
});

try {
    connection.start();
} catch (e) {
    console.error(e.toString());
}
//add signalR END